import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AdminEventSummary,
  callFetchAdminEventSummaries,
} from "../../../../api/eventTicketAdmin";
import LoadingSpinner from "../../../LoadingSpinner";
import ScrollableContainer from "../../components/ScrollableContainer";
import "../../components/Table.css";
import "./EventInfoPage.css";

function formatEventDateRange(start: string, end: string): string {
  const startDate = new Date(start);
  const datePart = startDate.toLocaleDateString("en-US", {
    dateStyle: "short",
  });
  return datePart;
}

const EventInfoPage = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState<AdminEventSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    callFetchAdminEventSummaries()
      .then(setEvents)
      .catch((err: Error) => setError(err.message || "Failed to load events"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-container">
      <h1>Event Checklist</h1>
      <p className="event-info-intro">
        Events currently published in Contentful. Select an event to view ticket
        sales and print a door checklist.
      </p>

      <div className="page-content event-info-page-content">
        {error && (
          <p className="error-message" role="alert">
            {error}
          </p>
        )}
        {loading ? (
          <LoadingSpinner />
        ) : events.length === 0 ? (
          <p>No events found.</p>
        ) : (
          <div className="order-table-container">
            <ScrollableContainer>
              <table className="table event-info-list-table">
                <thead className="sticky-table-head">
                  <tr>
                    <th className="th event-info-col-event">Event</th>
                    <th className="th event-info-col-date">Date</th>
                    <th className="th event-info-col-tickets">Tickets sold</th>
                  </tr>
                </thead>
                <tbody>
                  {events.map((event) => (
                    <tr
                      key={event._id}
                      className="event-info-clickable-row"
                      onClick={() => navigate(event._id)}
                    >
                      <td className="td td-left event-info-col-event">
                        {event.eventName}
                      </td>
                      <td className="td event-info-col-date">
                        {formatEventDateRange(
                          event.eventStartTime,
                          event.eventEndTime,
                        )}
                      </td>
                      <td className="td event-info-col-tickets">
                        {event.ticketsSold}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </ScrollableContainer>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventInfoPage;
